module.exports = "<h1 class=\"ssf-account-group__title\">{{ i18n + 'ACCESS-TO-ACCOUNTS' | translate }}</h1>\n\n<ssf-account-group *ngFor=\"let accountGroup of accountsGroups\"\n                   [accountGroup]=\"accountGroup\"\n                   (onAccountGroupClick)=\"onAccountGroupClick.emit($event)\"\n                   (onProductEnableToggle)=\"onProductEnableToggle.emit($event)\">\n</ssf-account-group>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/accounts-groups/accounts-groups.component.html
// module id = 830
// module chunks = 3